module.exports = __webpack_public_path__ + "static/img/home_fn_content_04.1692145.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/home_fn_content_04.png
// module id = 2esJ
// module chunks = 34